import { useState } from 'react';
import api from '../../hooks/useApi';

// ── Recording a Coupa approval from the chase Action ─────────────────────────
//
// Two weeks after a milestone is invoiced with no Coupa approval date, the
// Finance team get an Action to chase it (src/lib/coupaChaseActions.js). Once
// Coupa shows it approved, the date is recorded here rather than on the
// opportunity, which finance may not otherwise open.
//
// The date goes in through the ordinary milestone save, the same one the
// Coupa approved column makes, so the audit trail is the same and the server
// closes this Action for everyone as part of that save. An invoice that does
// not go through Coupa is closed with Mark done and a note instead.

export default function CoupaChaseEntry({ milestoneId, canDecide, onDecided }) {
  const today = new Date().toISOString().split('T')[0];
  const [date, setDate] = useState(today);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  if (!canDecide || !milestoneId) return null;

  const record = async () => {
    setBusy(true); setError('');
    try {
      await api.put(`milestones/${milestoneId}`, { coupa_approved: date });
      onDecided && onDecided();
    } catch (e) {
      setError(e?.message || 'That could not be saved. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-1.5 bg-gray-50 border border-gray-200 rounded px-2 py-1.5" onClick={e => e.stopPropagation()}>
      <div className="flex items-center gap-1.5 flex-wrap">
        <label htmlFor={`coupa-${milestoneId}`} className="text-[9px] text-gray-600">Approved on Coupa on</label>
        <input id={`coupa-${milestoneId}`} type="date" value={date} max={today} disabled={busy}
          onChange={e => { setDate(e.target.value); setError(''); }}
          className="text-[9px] border border-gray-300 rounded px-1.5 py-0.5 bg-white text-navy" />
        <button onClick={record} disabled={busy || !date}
          title={date ? 'Record the approval date on the milestone and close this for everyone' : 'Choose the date first'}
          className="px-2.5 py-1 text-[9px] font-semibold bg-emerald-600 text-white rounded hover:bg-emerald-700 disabled:opacity-30">
          {busy ? 'Saving…' : 'Record approval'}
        </button>
      </div>
      <div className="text-[8px] text-gray-400 mt-1">Not a Coupa invoice? Mark this done with a note saying so.</div>
      {error && <div className="mt-1 text-[9px] text-red-600">{error}</div>}
    </div>
  );
}
